import React, {Component} from 'react';

import {UserInfoProps, UserInfo} from 'etc/types';
import {SP_API_URL} from 'lib/shared/config/config';
import oauth from 'lib/shared/oauth/oauth';
import analytics from 'lib/client/analytics/analytics';
import {captureException} from 'lib/client/sentry/sentry';

export const UserInfoContext = React.createContext({});

export const withUserInfo = <P extends UserInfoProps>(Comp: React.ComponentType<P>) => {
  return (props: Omit<P, keyof UserInfoProps>) => (
    <UserInfoContext.Consumer>{userInfo => <Comp {...(props as P)} userInfo={userInfo} />}</UserInfoContext.Consumer>
  );
};

class UserInfoProvider extends Component<{}, UserInfo> {
  constructor(props: {}) {
    super(props);

    this.state = {
      loading: true,
      error: false,
      data: null,
    };
  }

  async componentDidMount() {
    try {
      const data = await oauth.getJSON(`${SP_API_URL}/v1/me`);

      analytics.setupUserProductForTracking(data.product);

      this.setState({
        loading: false,
        error: false,
        data: {
          username: data.id,
          displayName: data.display_name,
          email: data.email,
          avatar: data.images[0] ? data.images[0].url : '',
          followerCount: data.followers ? data.followers.total : 0,
          product: data.product,
        },
      });
    } catch (e) {
      analytics.setupUserProductForTracking(null);

      if (e.message === 'Token not received') {
        this.setState({loading: false});
        return;
      }

      captureException(e);
      this.setState({loading: false, error: true});
    }
  }

  render() {
    const {loading, error, data} = this.state;
    const contextValue = {
      loading,
      error,
      data,
    };

    return <UserInfoContext.Provider value={contextValue}>{this.props.children}</UserInfoContext.Provider>;
  }
}

export default UserInfoProvider;
